import IconComponent from "icons/IconComponent";

import LogoIcon from "./logoicon.svg";

export default (LogoIcon as any) as IconComponent;
